/**
 * 关键期限债券-相关品种
 */
import React, { useEffect, useState } from "react"
import QuoteTable from "../../../../modules/quote_table/list_tips"
import Param from "../../../../modules/public_fun/param"
import delayparams from "../../../../modules/url/delayQuote"
import { formatUniqueNumToFixed, formatCompareColor, formatTipsDate, formatDate } from "../../utils"

export function TipsRelevantType(props: { countryCode: string, duration:string, inflation:string}) {
  const [table, setTable] = useState<any>(null)
  const [pageSize, setPageSize] = useState(20)
  const [totalNum, setTotalNum] = useState(20)
  let quote_api_host = "//push2.eastmoney.com"

  if (Param.get("env") == "test") {
    quote_api_host = "//push2test.eastmoney.com"
  }
  const makeQuoteTable = () => {
    let quotetable = new QuoteTable({
      ele: "tips_relevant",
      api: `${quote_api_host}/api/qt/clist/get?cb=?&pn=1&np=1&ut=8a086bfc3570bdde64a6a1c585cccb35&fltt=1&invt=2&fs=m:171+y:2+p:1+n:${props.countryCode}+r:${props.duration}${props.inflation}&fields=f1,f2,f3,f4,f12,f13,f14,f15,f16,f17,f18,f31,f32,f124,f152,f211,f212,f277,f350,f486,f487,f488,f491,f492,f495,f497,f498,f499${delayparams}`,
      params: {
        // 默认参数配置
        sortkey: "f488",
        sortval: "0",
        size: "20",
      },
      right_tds: 3,
      refresh: 15,
      sortdesc: "1",
      sortasc: "0",
      keyword: "globalbond",
      type: "allTips",
      item: [
        {
          name: "name",
          title: "名称",
          html: function (data: any) {
            if (data == null) {
              return `<th class="relevant-title">${this.title}</th>`
            } else {
              return `<td><p>${data.f14}</p><p>${data.f12}</p></td>`
            }
          },
          sort: false,
        },
        {
          name: "year",
          title: "剩余期限",
          html: function (data: any) {
            if (data == null) {
              return `<th class="sort_normal">${this.title}</th>`
            } else {
              return `<td>${data.f488}</td>`
            }
          },
          sort: true,
          sortitem: {
            desvalue: "1",
            ascvalue: "0",
            key: "f488",
          },
        },
        {
          name: "zx",
          title: "最新",
          html: function (data: any) {
            if (data == null) {
              return `<th value="true" class="sort_normal">${this.title}</th>`
            } else {
              return `<td class="${data.f4 > 0 ? "shares-rise" : data.f4 < 0 ? "shares-fall" : ""}">${formatUniqueNumToFixed(data.f277, data.f1, 4)}</td>`
            }
          },
          sort: true,
          sortitem: {
            desvalue: "1",
            ascvalue: "0",
            key: "f277",
          },
        },
        {
          name: "zfe",
          title: "涨跌",
          html: function (data: any) {
            if (data == null) {
              return `<th class="sort_normal">${this.title}</th>`
            } else {
              return `<td class="${data.f4 > 0 ? "shares-rise" : data.f4 < 0 ? "shares-fall" : ""}">${formatUniqueNumToFixed(data.f4, data.f1, data.f1)}</td>`
            }
          },
          sort: true,
          sortitem: {
            desvalue: "0",
            ascvalue: "1",
            key: "f4",
          },
        },
        {
          name: "zdf",
          title: "涨跌幅",
          html: function (data: any) {
            if (data == null) {
              return `<th class="sort_normal">${this.title}</th>`
            } else {
              return `<td class="${data.f4 > 0 ? "shares-rise" : data.f4 < 0 ? "shares-fall" : ""}">${formatUniqueNumToFixed(data.f3, data.f152, data.f152, "%")}</td>`
            }
          },
          sort: true,
          sortitem: {
            desvalue: "0",
            ascvalue: "1",
            key: "f3",
          },
        },
        {
          name: "ytm",
          title: "最新YTM",
          html: function (data: any) {
            if (data == null) {
              return `<th class="sort_normal">${this.title}</th>`
            } else {
              return `<td class="${data.f497 == 1?(data.f4 > 0 ? "shares-rise" : data.f4 < 0 ? "shares-fall" : ""):(data.f4 < 0 ? "shares-rise" : data.f4 > 0 ? "shares-fall" : "")}">${formatUniqueNumToFixed(data.f350, data.f1, data.f1)}</td>`
            }
          },
          sort: true,
          sortitem: {
            desvalue: "1",
            ascvalue: "0",
            key: "f350",
          },
        },
        {
          name: "deadline",
          title: "到期日期",
          html: function (data: any) {
            if (data == null) {
              return `<th class="sort_normal">${this.title}</th>`
            } else {
              return `<td>${formatDate(data.f491 * 1000, "yyyy-MM-dd")}</td>`
            }
          },
          sort: true,
          sortitem: {
            desvalue: "1",
            ascvalue: "0",
            key: "f491",
          },
        },
        {
          name: "buy",
          title: "最优买",
          html: function (data: any) {
            if (data == null) {
              return `<th class="sort_normal">${this.title}</th>`
            } else {
              return `<td class="${formatCompareColor(data.f31, data.f18)}">${formatUniqueNumToFixed(data.f31, data.f1, data.f1)}</td>`
            }
          },
          sort: true,
          sortitem: {
            desvalue: "1",
            ascvalue: "0",
            key: "f31",
          },
        },
        {
          name: "buy_ytm",
          title: "最优买YTM",
          html: function (data: any) {
            if (data == null) {
              return `<th class="sort_normal">${this.title}</th>`
            } else {
              return `<td class="${data.f497 == 1?formatCompareColor(data.f31,data.f18):formatCompareColor(data.f18,data.f31)}">${formatUniqueNumToFixed(data.f499, data.f1, data.f1)}</td>`
            }
          },
          sort: true,
          sortitem: {
            desvalue: "1",
            ascvalue: "0",
            key: "f499",
          },
        },
        {
          name: "sell",
          title: "最优卖",
          html: function (data: any) {
            if (data == null) {
              return `<th class="sort_normal">${this.title}</th>`
            } else {
              return `<td class="${formatCompareColor(data.f32, data.f18)}">${formatUniqueNumToFixed(data.f32, data.f1, data.f1)}</td>`
            }
          },
          sort: true,
          sortitem: {
            desvalue: "1",
            ascvalue: "0",
            key: "f32",
          },
        },
        {
          name: "sell_YTM",
          title: "最优卖YTM",
          html: function (data: any) {
            if (data == null) {
              return `<th class="sort_normal">${this.title}</th>`
            } else {
              return `<td class="${data.f497 == 1?formatCompareColor(data.f32,data.f18):formatCompareColor(data.f18,data.f32)}">${formatUniqueNumToFixed(data.f498, data.f1, data.f1)}</td>`
            }
          },
          sort: true,
          sortitem: {
            desvalue: "1",
            ascvalue: "0",
            key: "f498",
          },
        },
        {
          name: "jk",
          title: "今开",
          html: function (data: any) {
            if (data == null) {
              return `<th class="sort_normal">${this.title}</th>`
            } else {
              return `<td class="${formatCompareColor(data.f17, data.f18)}">${formatUniqueNumToFixed(data.f17, data.f1, data.f1)}</td>`
            }
          },
          sort: true,
          sortitem: {
            desvalue: "1",
            ascvalue: "0",
            key: "f17",
          },
        },
        {
          name: "zg",
          title: "最高",
          html: function (data: any) {
            if (data == null) {
              return `<th class="sort_normal">${this.title}</th>`
            } else {
              return `<td class="${formatCompareColor(data.f15, data.f18)}">${formatUniqueNumToFixed(data.f15, data.f1, data.f1)}</td>`
            }
          },
          sort: true,
          sortitem: {
            desvalue: "1",
            ascvalue: "0",
            key: "f15",
          },
        },
        {
          name: "zd",
          title: "最低",
          html: function (data: any) {
            if (data == null) {
              return `<th class="sort_normal">${this.title}</th>`
            } else {
              return `<td class="${formatCompareColor(data.f16, data.f18)}">${formatUniqueNumToFixed(data.f16, data.f1, data.f1)}</td>`
            }
          },
          sort: true,
          sortitem: {
            desvalue: "1",
            ascvalue: "0",
            key: "f16",
          },
        },
        {
          name: "zs",
          title: "昨收",
          html: function (data: any) {
            if (data == null) {
              return `<th class="sort_normal">${this.title}</th>`
            } else {
              return `<td>${formatUniqueNumToFixed(data.f18, data.f1, data.f1)}</td>`
            }
          },
          sort: true,
          sortitem: {
            desvalue: "1",
            ascvalue: "0",
            key: "f18",
          },
        },
        {
          name: "update",
          title: "更新时间",
          html: function (data: any) {
            if (data == null) {
              return `<th class="sort_normal">${this.title}</th>`
            } else {
              return `<td>${formatTipsDate(data.f124 * 1000, "hh:mm:ss")}</td>`
            }
          },
          sort: true,
          sortitem: {
            desvalue: "1",
            ascvalue: "0",
            key: "f124",
          },
        },
        {
          name: "country",
          title: "国家/地区",
          html: function (data: any) {
            if (data == null) {
              return `<th class="sort_normal">${this.title}</th>`
            } else {
              return `<td>${data.f492}</td>`
            }
          },
          sort: true,
          sortitem: {
            desvalue: "1",
            ascvalue: "0",
            key: "f492",
          },
        },
        {
          name: "currency",
          title: "货币",
          html: function (data: any) {
            if (data == null) {
              return `<th class="sort_normal">${this.title}</th>`
            } else {
              return `<td>${data.f495}</td>`
            }
          },
          sort: true,
          sortitem: {
            desvalue: "1",
            ascvalue: "0",
            key: "f495",
          },
        },
      ],
    })
    quotetable.init()
    return quotetable
  }

  const loadMore = async () => {
    try {
      let data = await table.showMore(20)
      setPageSize(pageSize + 20)
      setTotalNum(data.data.diff.length)
    } catch (error) {
      setPageSize(0)
      setTotalNum(0)
    }
  }

  useEffect(() => {
    if(props.countryCode){
      let table:any = makeQuoteTable()
      setTable(table)
    }
  }, [])

  return (
    <div className="tips-relevant">
      <div id="tips_relevant"></div>
      <div className="stockmore-loadmore" onClick={loadMore}>
        {
          totalNum > 0 && pageSize <=  totalNum  && <span>查看更多<i className="arrow-down"></i></span>
        }
        {
            !totalNum && <span>暂无数据</span>
        }
        {
          pageSize > totalNum && totalNum > 0 && <span>已经到底了</span>
        }
      </div>
    </div>
  )
}
